import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { Employee } from "../../../classes/employee";
import { StringService } from "../../../services/string.service";
import { DateService } from "../../../services/date.service";
import { ConstantsService } from "../../../services/constants.service";
import { IConstants } from "../../../interfaces/i-constants";
import { CompareService } from "../../../services/compare.service";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { DateSorterPipe } from "../../../pipes/date-sorter.pipe";

@Component({
  selector: "app-history",
  templateUrl: "./history.component.html",
  styleUrls: ["./history.component.scss"],
  standalone: true,
  imports: [
    DatePipe,
    FormsModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    DateSorterPipe,
  ],
})
export class HistoryComponent implements OnInit {
  @Input() employee: Employee;
  @Input() fieldsEnabled: boolean;
  public constants: IConstants;

  constructor(
    public stringsService: StringService,
    public dateService: DateService,
    private constantsService: ConstantsService,
    public compareService: CompareService,
    private cdr: ChangeDetectorRef,
  ) {
    this.constants = constantsService.constants;
  }

  ngOnInit() {
    this.constantsService.change.subscribe((constants: IConstants) => {
      this.constants = constants;
      this.cdr.markForCheck();
    });
  }
}
